import { GET_MODELOS_MAQUINA, MODIFY_MODELO_MAQUINA, ADD_MODELO_MAQUINA, DELETE_MODELO_MAQUINA, UPDATE_MODELOS_MAQUINA } from '../constants/action_types';

const initialState = {
    modelosmaquina: [],
    isLoading: false
};

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_MODELOS_MAQUINA:

            return {
                modelosmaquina: [],
                isLoading: true
            };
        case GET_MODELOS_MAQUINA + "_SUCCESS":
        
            return {
                modelosmaquina: action.payload.data,
                isLoading: false
            };

        case ADD_MODELO_MAQUINA:

            const newArr = [...state.modelosmaquina, action.payload]
            return {
                modelosmaquina: newArr,
                isLoading: false
            };

        case MODIFY_MODELO_MAQUINA:

            return {
                modelosmaquina: state.modelosmaquina.map((tipoZona) => {
                    if (tipoZona.id !== action.payload.id) return tipoZona;
                    else return action.payload
                }),
                isLoading: false
            };

        case DELETE_MODELO_MAQUINA:

            return {
                modelosmaquina: state.modelosmaquina.filter(tipoZona => tipoZona.id !== action.payload.id),
                isLoading: false
            };

        case UPDATE_MODELOS_MAQUINA + "_SUCCESS":

            return state;

        default:

            return state;
    }
}